import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared.module';
import { HeaderComponent } from './header/header.component';
import { SearchComponent } from './search/search.component';
import { SideNavComponent } from './side-nav/side-nav.component';
import { FooterComponent } from './footer/footer.component';
import { ThemeConstantService } from '../services/theme-constant.service';
import {SideNavDirective} from '../directives';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';

@NgModule({
    exports: [
        CommonModule,
        NzIconModule,
        HeaderComponent,
        SearchComponent,
        SideNavComponent,
        SideNavDirective,
        FooterComponent
    ],
    imports: [
        RouterModule,
        CommonModule,
        SharedModule,
        NzLayoutModule,
        NzIconModule,
        NzAvatarModule,
        NzDropDownModule
    ],
    declarations: [
        HeaderComponent,
        SearchComponent,
        SideNavComponent,
        SideNavDirective,
        FooterComponent
    ],
    providers: [
        ThemeConstantService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class TemplateModule { }
